export function nextMobileRatingFocusIndex(currentIndex: number, key: string, optionCount: number): number {
  if (optionCount <= 0) return 0;
  if (key === "Home") return 0;
  if (key === "End") return optionCount - 1;
  const direction = key === "ArrowLeft" || key === "ArrowUp" ? -1 : 1;
  return (currentIndex + direction + optionCount) % optionCount;
}
